const area = (el) => {
    const filters = el.querySelectorAll('.js-area-filter');
    if (filters.length) {
        [].forEach.call(filters, function(activeEl) {
            filter(activeEl, el);
        });
    }

    const items = el.querySelectorAll('.js-area-item');
    if (items.length) {
        [].forEach.call(items, function(activeEl) {
            item(activeEl);
        });
    }
};

const filter = (el, container) => {
    const value = el.dataset.value;
    el.addEventListener('click', function() {
        const isSelected = el.classList.contains('js-state-filter--active');
        if(isSelected) {
            el.classList.remove('js-state-filter--active');
        } else {
            el.classList.add('js-state-filter--active');
        }

        // If none of the buttons are selected, all should be shown
        const buttons = container.querySelectorAll('.js-area-filter.js-state-filter--active');
        const showAll = buttons.length === 0;

        // Deselect other buttons
        [].forEach.call(buttons, function(activeEl) {
            if(activeEl !== el) {
                activeEl.classList.remove('js-state-filter--active');
            }
        });

        const elements = container.querySelectorAll('.js-area-list li[data-filter]');
        [].forEach.call(elements, function(activeEl) {
            const itemFilter = activeEl.dataset.filter;
            if(showAll) {
                activeEl.style.display = 'block';
            } else if(itemFilter === value) {
                activeEl.style.display = !isSelected ? 'block' : 'none';
            } else if(!isSelected) {
                activeEl.style.display = 'none';
            }
        });

    });
};

const createMarkerStaticMap = ({
    baseUrl,
    markerStyle,
    activeMarkerStyle,
    markers,
}, activeId) => {
    // Display active item as marker
    const activeMarker = markers[activeId] || null;
    const activeParam = activeMarker ? `&markers=${activeMarkerStyle}|${activeMarker}` : '';

    // Clone markers and remove the active marker
    const cloneMarkers = {...markers};
    delete cloneMarkers[activeId];

    // Display all markers
    const markersParam = cloneMarkers ? Object.values(cloneMarkers).join('|') : '';
    return `${baseUrl}${activeParam}&markers=${markerStyle}|${markersParam}`;
};

const item = (el) => {
    const button = el.querySelector('button');
    const tabId = el.dataset.tabId;
    const map = document.getElementById('map-static-'+tabId);
    const defaultMap = map.src;
    const data = window['map_static_area_' + tabId];
    if (!data) {
        return;
    }

    button.addEventListener('click', function() {
        // Deactivate if already active
        if(el.classList.contains('js-state-area-item--active')) {
            el.classList.remove('js-state-area-item--active');
            map.src = defaultMap;
        } else {
            el.classList.add('js-state-area-item--active');
            const activeId = el.dataset.areaId;
            map.src = createMarkerStaticMap(data, activeId);

            var elements = document.querySelectorAll('.js-state-area-item--active');
            [].forEach.call(elements, function(activeEl) {
                if(activeEl !== el) {
                    activeEl.classList.remove('js-state-area-item--active');
                }
            });
        }
    });
};

export default area;